export const colors = {
  white: '#fff',
  graphite: '#666',
  grey: '#8a96a3',
  yellowOrange: '#ff9933',
  orange: '#ed5f55',
  orangeDark: '#d8574e',
  blue: '#3a81b7',
  blueLight: '#64a0ce'
};

// d02216